import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { CommonFunctionService, UserMerchantData } from 'src/app/services/Common/common-function.service';
import { environment } from 'src/environments/environment';
import { TransactionService } from 'src/app/services/transaction/transaction.service';
import { ReportsService } from 'src/app/services/reports/reports.service';
const _clone = (d) => JSON.parse(JSON.stringify(d));
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-payoutwebhookdata',
  templateUrl: './payoutwebhookdata.component.html',
  styleUrls: ['./payoutwebhookdata.component.scss']
})
export class PayoutwebhookdataComponent implements OnInit {
  excelTansactionDataResponse = [];
  MerchantKeyId: any;
  temp = [];
  rows = [];
  rowsFilter = [];
  rowsExp = [];
  rowsSort = [];
  rowsSel = [];
  dataList: any[];
  paymentType: any;
  //daterange = new FormControl("", [Validators.required]);
  isCustomDateSelected: boolean = false;

  isStartDateGreaterthenEndDate: boolean = false;
  datePickerDay: any;
  datePickerMonth: any;
  datePickerYear: any;
  datePickerMaxDate: any;

  isreportsbtnActive: boolean = false;
  filtering: boolean = false;
  Rfromdate: boolean = false;
  Dfiltering: boolean = true;
  Fromdate1: any;
  todate1: any;
  todate = new FormControl("", [Validators.required]);
  fromdate = new FormControl("", [Validators.required]);
  daterange = new FormControl("", [Validators.required]);

  Range = [
    { text: "Today", value: "0" },
    { text: "Yesterday", value: "2" },
    { text: "current week", value: "4" },
    // { text: "Last Week", value: "1" },
  // { text: "This Month", value: "1" },
    // { text: "Last Month", value: "2" },
    // { text: "Custom Date Range", value: "4" }
  ];


  
  constructor(private commonfunction: CommonFunctionService, private transactionservice: TransactionService,private service: ReportsService) {
    const merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.MerchantKeyId = merchantdata.MerchantKeyId
    this.Getposbackdata((data) => {
      // cache our list
      // this.temp = _clone(data);
      // this.rows = _clone(data);;
      // this.rowsFilter = _clone(data);;
      // this.rowsExp = _clone(data);
      // this.rowsSort = _clone(data);
      // this.rowsSel = _clone(data);
      // this.dataList = data;
    });
   }

   Getposbackdata(cb) {
    const req = new XMLHttpRequest();
    this.service.GetpayoutposbackdataUrl(this.MerchantKeyId).subscribe(data => {
      if(data !=null)
      {
    this.temp = _clone(data);
    this.rows = _clone(data);;
    this.rowsFilter = _clone(data);;
    this.rowsExp = _clone(data);
    this.rowsSort = _clone(data);
    this.rowsSel = _clone(data);
    this.dataList = data;
      }
    });
    // req.open('GET', environment.GetposbackdataUrl + "?merchantKeyId=" + this.MerchantKeyId);
    // // req.open('GET', `https://uatapi.fastswiff.com/virtualPOS/api/Transaction/Manage?MerchantKeyId=3`);
    // //  req.open('GET', this.service.GetTransactions(81));


    // req.onload = () => {
    //   cb(JSON.parse(req.response));
    // };

    // req.send();
  }
  ngOnInit() {
  }

  checkRangeType() {
    var daterange = this.daterange.value;
    if (daterange == "Custom Date Range") {
      this.isCustomDateSelected = true;
      this.isStartDateGreaterthenEndDate = false;
      this.Rfromdate = true;
      this.Dfiltering = false;
      this.fromdate.setValue('');
      this.todate.setValue('');
      this.isreportsbtnActive = false;
    }
    else {
      this.isCustomDateSelected = false;
      this.isStartDateGreaterthenEndDate = false;
      this.Rfromdate = false;
    }
  }
  filters() {
    //   this.filtering=true;
    this.filtering = !this.filtering;
  }

  selectedaterange() {
    var daterange = this.daterange.value;
    if (daterange == "Custom Date Range") {
      this.isCustomDateSelected = true;
      this.isStartDateGreaterthenEndDate = false;
      this.Rfromdate = true;
      this.Dfiltering = false;
    }
    else {
      this.isCustomDateSelected = false;
      this.isStartDateGreaterthenEndDate = false;
      this.Rfromdate = false;
      this.search();

    }
  }

  getmaxDate() {
    var dtToday = new Date();

    this.datePickerMonth = dtToday.getMonth() + 1;
    this.datePickerDay = dtToday.getDate();
    this.datePickerYear = dtToday.getFullYear();

    if (this.datePickerMonth < 10)
      this.datePickerMonth = '0' + this.datePickerMonth.toString();
    if (this.datePickerDay < 10)
      this.datePickerDay = '0' + this.datePickerDay.toString();
    this.datePickerMaxDate = this.datePickerYear + '-' + this.datePickerMonth + '-' + this.datePickerDay;
  }
  checkDateRange() {
    if (this.fromdate.value != "" && this.todate.value != "") {
      if (this.fromdate.value > this.todate.value) {
        this.isreportsbtnActive = false;
        this.isStartDateGreaterthenEndDate = true;
      }
      else {
        this.isreportsbtnActive = true;
        this.isStartDateGreaterthenEndDate = false;
      }
    }
    else {
      this.isreportsbtnActive = false;
      this.isStartDateGreaterthenEndDate = false;
    }
  }

  search() {
    this.GetPostbackdatafilter((data) => {
      // cache our list
      // this.temp = _clone(data);
      // this.rows = _clone(data);;
      // this.rowsFilter = _clone(data);;
      // this.rowsExp = _clone(data);
      // this.rowsSort = _clone(data);
      // this.rowsSel = _clone(data);

    });
  }

  GetPostbackdatafilter(cb) {
    var daterange = this.daterange.value;
    //alert( this.transactionType.value)

    // if (bid == "") {
    //   bid = 0
    // }
    if (daterange == "Today") {
      this.Fromdate1 = new Date().toISOString().slice(0, 10);
      this.todate1 = new Date().toISOString().slice(0, 10);

    }
    else if (daterange == "Yesterday") {
      const today = new Date();
      const tomorrow = new Date(today.setDate(today.getDate() - 1)).toISOString().slice(0, 10);
      this.Fromdate1 = tomorrow;
      this.todate1 = tomorrow;
    }
    else if (daterange == "current week") {
      const today = new Date();
      const tomorrow = new Date(today.setDate(today.getDay()));


      var current = new Date();
      var weekstart = current.getDate() - current.getDay() + 1;
      var weekend = weekstart + 6;
      this.Fromdate1 = new Date(current.setDate(weekstart)).toISOString().slice(0, 10);
      this.todate1 = new Date().toISOString().slice(0, 10);
    }
    else if (daterange == "Last Week") {
      var curr = new Date;
      var first = curr.getDate() - curr.getDay() - 6;
      var last = first + 6;
      this.Fromdate1 = new Date(curr.setDate(first)).toISOString().slice(0, 10);
      this.todate1 = new Date(curr.setDate(last)).toISOString().slice(0, 10);

    }
    else if (daterange == "This Month") {
      const today = new Date();
      // const thismonth = new Date(today.setDate(today.getMonth())).toISOString().slice(0, 10);
      //this.Fromdate1=thismonth;   
      this.Fromdate1 = new Date(today.getFullYear(), today.getMonth(), 1).toDateString();
      this.todate1 = new Date().toISOString().slice(0, 10);

    }
    else if (daterange == "Last Month") {
      //  var date = new Date();                
      //  this.Fromdate1 = new Date(date.getFullYear(), date.getMonth() - 1, 1).toISOString().slice(0,10);
      //  this.todate1 = new Date(date.getFullYear(), date.getMonth() - 1 + 1, 0).toISOString().slice(0,10);


      var date = new Date();
      this.Fromdate1 = new Date(date.getFullYear(), date.getMonth() - 1, 1).toDateString();
      this.todate1 = new Date(date.getFullYear(), date.getMonth() - 1 + 1, 0).toDateString();;

      // alert(monthStartDay);alert(monthEndDay);


    }
    else if (daterange == "Custom Date Range") {

      this.Fromdate1 = this.fromdate.value;
      this.todate1 = this.todate.value;

    }
    else {
      this.Fromdate1 = new Date().toISOString().slice(0, 10);
      this.todate1 = new Date().toISOString().slice(0, 10);

    }

    this.service.GetPayoutPostbackdatafilterurl(this.MerchantKeyId,this.Fromdate1,this.todate1).subscribe(data => {
      if(data !=null)
      {
    this.temp = _clone(data);
    this.rows = _clone(data);;
    this.rowsFilter = _clone(data);;
    this.rowsExp = _clone(data);
    this.rowsSort = _clone(data);
    this.rowsSel = _clone(data);
      }

    });
   
  }

  readAndExportTransactionData() {
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    if (this.rows.length > 0) {
      this.rows.forEach(element => {

        var manageTranArray = { 'OrderKeyId': element.OrderKeyId, 'LogMessage': element.LogMessage, 'Updated DateTime': element.UpdatedDateTime,'StatusCode': element.StatusCode}
        this.excelTansactionDataResponse.push(manageTranArray);
      });

      const manageTransactionWorkSheet = XLSX.utils.json_to_sheet(this.excelTansactionDataResponse, { header: ['OrderKeyId', 'LogMessage','StatusCode' ,'Updated DateTime'] });
      XLSX.utils.book_append_sheet(workBook, manageTransactionWorkSheet, 'MMSTransactionSummaryList_tbl');
    }
    XLSX.writeFile(workBook, "Excel" + new Date().getTime() + '.xlsx');
    this.excelTansactionDataResponse = [];
  }

}
